var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ball-scale-multiple loader",class:( _obj = {}, _obj[("la-" + _vm.size)] = true, _obj[("la-" + _vm.color)] = true, _obj )},_vm._l((3),function(index){return _c('div',{key:index})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }